// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  calendarDateConverter_parseError: () =>
    'Bandykite dar kartą naudodami tokią įvykdymo datą: {dateExample}.',
  chart_labelGroup: () => 'Grupė',
  chart_labelSeries: () => 'Serija',
  chart_labelValue: () => 'Reikšmė',
  checkboxSet_requiredMessageDetail: () => 'Būtina',
  checkbox_requiredMessageDetail: () => 'Būtina',
  close: () => 'Uždaryti',
  collection_noData: () => 'Nėra rodytinų duomenų.',
  collection_selectAllRows: () => 'Pasirinkti visas eilutes',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Pasirinkti eilutę ' + p['ROW_NAME'],
  collection_sortDisabled: () => 'Nerikiuojama',
  collection_sortEnabled: () => 'Rikiuojama',
  confirmation: () => 'Patvirtinimas',
  dataVisualization_labelAndValue: (p: { LABEL: string; VALUE: string }) =>
    p['LABEL'] + ': ' + p['VALUE'],
  dataVisualization_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' iš ' + p['totalCount'],
  dataVisualization_noData: () => 'Nėra rodytinų duomenų',
  dataVisualization_stateSelected: () => 'Pasirinkta',
  dataVisualization_stateUnselected: () => 'Nepasirinkta',
  error: () => 'Klaida',
  expandableList_expandCollapseInstructionText: () =>
    'Naudokite rodyklių klavišus norėdami išskleisti ir sutraukti',
  expandableList_groupCollapse: () => 'Sutraukta',
  expandableList_groupExpand: () => 'Išskleista',
  filePicker_addFiles: () => 'Įtraukti failų',
  filePicker_dropzonePrimaryText: () => 'Nuvilkimas',
  filePicker_dropzoneSecondaryText: () => 'Pasirinkite failą arba jį nuvilkite čia',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Pasirinkite arba nuvilkite failus čia',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Šio tipo failų įkelti negalima: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Vienu kartu galima įkelti vieną failą',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    p['fileType'] + ' tipo failų įkelti negalima',
  filePicker_unknownFileTypeUploadError: () => 'nežinoma',
  formControl_clear: () => 'Valyti',
  formControl_day: () => 'Diena',
  formControl_helpAvailable: () => 'Žinynas pasiekiamas',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Pasiekėte ribą ' +
    ((
      {
        one: '1 character',
        few: new Intl.NumberFormat('lt').format(p['CHARACTER_LIMIT']) + ' characters',
        many: new Intl.NumberFormat('lt').format(p['CHARACTER_LIMIT']) + ' characters'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('lt').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('lt').format(p['CHARACTER_LIMIT']) + ' characters') +
    '.',
  formControl_loading: () => 'Įkeliama',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Viršytas maksimalus ilgis ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' simboliai (-ių) liko.',
  formControl_month: () => 'Mėnuo',
  formControl_readOnly: () => 'Tik skaityti',
  formControl_requiredMessageDetail: () => 'Įveskite reikšmę.',
  formControl_year: () => 'Metai',
  gantt_labelDate: () => 'Data',
  gantt_labelEnd: () => 'Baigti',
  gantt_labelLabel: () => 'Žyma',
  gantt_labelRow: () => 'Eilutė',
  gantt_labelStart: () => 'Pradėti',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nerasta jokių atitinkančių skyrių.',
  indexer_keyboardInstructionText: () => 'Norėdami pasirinkti reikšmę, paspauskite Enter.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Tarp ' + p['FROM_SECTION'] + '  ir ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Du kartus spustelėkite ir palaikykite, kad įjungtumėte gestų režimą, tada vilkite aukštyn arba žemyn, kad koreguotumėte reikšmę.',
  info: () => 'Informacija',
  inputDateMask_date_cleared: () => 'Data išvalyta',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Tuščia',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'mmmm',
  inputNumber_converterParseError: () => 'Įveskite skaičių.',
  inputNumber_decrease: () => 'Sumažinti',
  inputNumber_increase: () => 'Padidinti',
  inputPassword_hidden: () => 'Slaptažodis paslėptas',
  inputPassword_hide: () => 'Slėpti slaptažodį',
  inputPassword_show: () => 'Rodyti slaptažodį',
  list_suggestion: () => 'Pasiūlymas',
  messageToast_allMessagesClosed: () => 'Visi informaciniai pranešimai uždaryti.',
  message_close: () => 'Uždaryti',
  message_confirmation: () => 'Pavyko',
  message_error: () => 'Klaida',
  message_info: () => 'Informacija',
  message_navigationFromMessagesRegion: () =>
    'Įeinama į pranešimų sritį. Paspauskite F6, kad grįžtumėte prie ankstesnio pasirinkto elemento.',
  message_navigationToMessagesRegion: () =>
    'Pranešimų srityje yra naujų pranešimų. Paspauskite F6, kad grįžtumėte prie naujausių pranešimų srities.',
  message_warning: () => 'Perspėjimas',
  noData_message: () => 'Nėra rodytinų elementų',
  overflowItemLabel: () => 'Daugiau skirtukų',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'Vykdoma',
  radio_helpForRadio: () => 'Išrinkimo mygtuko žinynas',
  radio_requiredMessageDetail: () => 'Pasirinkite reikšmę.',
  selectMultiple_apply: () => 'Taikyti',
  selectMultiple_back: () => 'Atgal',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Paspauskite Grįžti arba Naikinti, kad pašalintumėte pasirinktą reikšmę.',
  selectMultiple_selectedValues: () => 'Parinktos reikšmės',
  selectMultiple_showSelectedValues: () => 'Rodyti tik pasirinktas reikšmes.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Pasirinkta reikšmių: ' + p['VALUE_COUNT'] + '.',
  select_addToList: () => 'Įtraukti į sąrašą',
  select_addToListAvailable: () => 'Įtraukimas į sąrašą prieinamas',
  select_moreSearchOptions: () => 'Daugiau paieškos parinkčių',
  select_moreSearchOptionsAvailable: () => 'Daugiau ieškos parinkčių prieinama',
  select_noMatchesFound: () => 'Atitikmenų nerasta.',
  select_oneMatchFound: () => 'Rastas vienas atitikmuo',
  select_requiredMessageDetail: () => 'Pasirinkite reikšmę.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Rasta ' + p['TOTAL_SIZE'] + ' atitikmenų',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Rasta ' + p['TOTAL_SIZE'] + ' arba daugiau atitikmenų',
  selector_selected: () => 'Žymės langelis pažymėtas',
  selector_unselected: () => 'Žymės langelis nepažymėtas',
  tabBarNavigationList_removeCueText: () => 'Pašalinama',
  timeComponent_tooltipZoomIn: () => 'Artinti',
  timeComponent_tooltipZoomOut: () => 'Tolinti',
  train_current: () => 'Dabartinis',
  train_message_type: () => 'Pranešimo tipas',
  train_not_visited: () => 'Neaplankyta',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    p['currentStep'] + ' žingsnis iš ' + p['numberOfSteps'],
  train_visited: () => 'Aplankyta',
  userAssistance_learnMore: () => 'Sužinokite daugiau',
  userAssistance_required: () => 'Būtina',
  viz_drillable: () => 'Kilmė analizuojama',
  warn: () => 'Perspėjimas'
};
export default bundle;
